<template>
  <Transition name="appear">
    <div
      v-if="isOpen"
      class="cookie"
      :class="containerPosition"
      data-cy="cookie-banner"
    >
      <div class="container cookie__wrapper">
        <div class="cookie__content">
          Мы&nbsp;используем файлы cookies и&nbsp;сервис Яндекс.Метрика.
          Оставаясь на&nbsp;сайте, вы&nbsp;соглашаетесь с&nbsp;<a
            :href="POLICY_URL"
            target="_blank"
            rel="noopener noreferrer"
            >Политикой обработки персональных данных</a
          >.
        </div>
        <div class="cookie__buttons">
          <BaseButton
            class="cookie__button accept"
            data-cy="cookie-accept"
            size="sm"
            theme="primary"
            @click="accept"
          >
            Понятно
          </BaseButton>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { ACCEPT_COOKIE_NAME, ACCEPT_COOKIE_TTL } from "@/constants";
import { getCookie, setCookie } from "@/utils";

export default {
  name: "CookieBanner",
  props: {
    position: {
      type: String,
      default: "bottom",
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    containerPosition() {
      return `cookie__${this.position}`;
    },
    isCookieAccepted() {
      return Boolean(getCookie(ACCEPT_COOKIE_NAME));
    },
  },
  created() {
    this.POLICY_URL = `${process.env.VUE_APP_TALENT_HOST}/policy`;
  },
  mounted() {
    this.isOpen = !this.isCookieAccepted;
  },
  methods: {
    accept() {
      this.isOpen = false;
      setCookie(ACCEPT_COOKIE_NAME, true, {
        maxAge: ACCEPT_COOKIE_TTL,
        sameSite: "Strict",
        path: "/",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cookie {
  position: fixed;
  z-index: 9999;
  left: 0;
  right: 0;
  width: 100%;
  font-size: 0.95rem;
  background: @background-blue;
  color: @base-color;
  box-shadow: @shadow-middle;
  border-top: 1px solid fade(@primary-color, 18%);

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    @media screen and (max-width: @screen-sm) {
      & {
        flex-direction: column;
        align-items: flex-start;
      }
    }
  }

  &__content {
    align-items: center;
    margin-right: 10px;
    flex-grow: 1;
    color: @base-color;
    font-size: @font-size-m;
    text-align: left;

    @media screen and (max-width: @screen-sm) {
      & {
        margin-bottom: 12px;
      }
    }
  }

  &__buttons {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    margin-left: 10px;

    @media screen and (max-width: @screen-sm) {
      & {
        width: 100%;
        justify-content: flex-end;
      }
    }
  }

  &__button {
    min-width: 140px;
    width: initial;
    white-space: nowrap;

    @media screen and (max-width: @screen-sm) {
      min-width: 120px;
    }

    &.deny {
      margin-top: 0;
    }
  }

  &__top {
    top: 0;
    left: 0;
    right: 0;
  }
  &__bottom {
    bottom: 0;
    left: 0;
    right: 0;
  }
}

.appear-enter-active,
.appear-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.appear-enter {
  transform: translateY(8px);
  opacity: 0;
}
.appear-enter-to {
  transform: translateY(0);
  opacity: 1;
}
.appear-leave-to {
  transform: translateY(8px);
  opacity: 0;
}
</style>
